import { Fragment, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { uploadIcon } from '../../../components/common/Icons';
import { track } from '../../../tracking';
import { PPRouterProps } from '../../../routes/paths';
import { configs } from './MagicBoxConfigs';
import { MAGIC_BOX_COMPONENTS } from './MAGIC_BOX_COMPONENTS';
import { changePathAndFocus } from './magicBoxUtils';
import { getDoctorSelectorList, getPrescriptionById } from '../../../store/idbHandler';
import { RequestRecordsBt } from '../../MedicalRecordsRightPanel';
import { requestMedicalRecords } from '../../../api/requestMedicalRecords';

const uploadMRIcon = uploadIcon('fill-darwin-primary-500');

const MREmpty: React.FC = () => {
    const history = useHistory();
    const params: PPRouterProps = useParams();
    const { pxId, pxState } = params;
    const [ptId, setPtId] = useState('');
    const handleCta = () => {
        track('MAGIC_BOX_FOCUS_CARD', { key: 'mr' });
        changePathAndFocus(
            configs[MAGIC_BOX_COMPONENTS.MEDICAL_RECORDS].elId,
            history,
            pxId,
            pxState,
            'patient-overview',
        );
    };
    getPrescriptionById(pxId).then((i) => {
        setPtId(i.patient.id || '');
    });

    const onClickRequestRecordsBt = () => {
        requestMedicalRecords(getDoctorSelectorList()?.[0].id, ptId);
    };

    return (
        <Fragment>
            <p className="text-13 w-168 m-auto text-center mt-48 mb-32 text-darwin-neutral-800 font-400">
                You can see your patient's{' '}
                <span
                    onClick={handleCta}
                    className="font-700 text-darwin-accent-mauve-800 cursor-pointer hover:underline hover:underline-darwin-accent-mauve-800"
                >
                    medical records
                </span>{' '}
                here
            </p>

            <div className="m-21 -mt-12 mb-26 space-y-12">
                <div>
                    <p className="text-10 font-700 bg-darwin-accent-mauve-900 text-white w-max m-auto px-10 py-5 relative top-11">
                        EXAMPLE REPORT
                    </p>
                    <div className="flex-col space-y-10 px-12 pt-24 pb-10 bg-darwin-accent-mauve-100 border border-darwin-accent-mauve-200 rounded-4">
                        <p className="h-7 flex justify-center">
                            <span className="w-84 rounded-full bg-darwin-accent-mauve-200"></span>
                            <span className="w-38 rounded-full bg-darwin-accent-mauve-200 ml-21"></span>
                        </p>
                        <p className="w-144 h-7 rounded-4 bg-darwin-accent-mauve-200 m-auto"></p>
                        <p className="h-7 flex justify-center">
                            <span className="w-34 rounded-full bg-darwin-accent-mauve-200"></span>
                            <span className="w-34 rounded-full bg-darwin-accent-mauve-200 mx-21"></span>
                            <span className="w-34 rounded-full bg-darwin-accent-mauve-200"></span>
                        </p>
                        <p className="text-darwin-accent-mauve-900 text-13 text-center">
                            Complete blood count.pdf
                        </p>
                    </div>
                </div>
            </div>

            {handleCta && (
                <button
                    onClick={handleCta}
                    className="flex items-center space-x-8 font-700 text-14 border border-darwin-primary-500 p-9 px-16 m-auto rounded-4 text-darwin-primary-500"
                >
                    <span>{uploadMRIcon}</span>
                    <span>Upload Record</span>
                </button>
            )}

            {/* <RequestRecordsBt
                text="Request from Patient"
                className="font-700 m-auto text-darwin-primary-500 mt-22"
                onClick={onClickRequestRecordsBt}
            /> */}
        </Fragment>
    );
};

export default MREmpty;
